// @ts-nocheck
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import React, { FC } from "react";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { useTrailerTrackingV2DataView } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import updateParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateParameter";

export interface TrailerTrackingV2PaginationProps {}

export interface TrailerTrackingV2PaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const trailerTrackingV2PaginationStyles: TrailerTrackingV2PaginationStyles = {};

const styles = trailerTrackingV2PaginationStyles;

const TrailerTrackingV2Pagination: FC<TrailerTrackingV2PaginationProps> = () => {
    const dispatch = useAppDispatch();
    const { pagination } = usePersistentDataView(useTrailerTrackingV2DataView());

    if (!pagination?.totalItemCount) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            currentPage={pagination.currentPage}
            resultsPerPage={pagination.pageSize}
            resultsCount={pagination.totalItemCount}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={page => dispatch(updateParameter({ page }))}
            onChangeResultsPerPage={event =>
                dispatch(updateParameter({ pageSize: parseInt(event.currentTarget.value, 10) }))
            }
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

export default TrailerTrackingV2Pagination;
